import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AccountService} from '../../account/account.service';
import {CommonDataService} from '../../shared/services/common-data.service';
import {SettingsService} from '../../shared/services/settings.service';
import {CampaignService} from '../campaign.service';
import {FundraiserOrderMaterialsService} from '../../orders/materials/fundraiser-order-materials.service';
import {Router} from '@angular/router';
import {UserService} from '../../users/user.service';
import {ScrollTopService} from '../../shared/services/scroll-top.service';

@Component({
    selector: 'app-campaign-create',
    templateUrl: './campaign-create.component.html',
    styleUrls: ['./campaign-create.component.css']
})
export class CampaignCreateComponent implements OnInit {

    msg = [];
    defaultDate = new Date('2022-09-30T00:00:00-08:00');
    startDate = this.defaultDate;
    formGroup: FormGroup;
    currentUser;
    nonProfit: Boolean;
    orgTypeList = [];
    salesRepList = [];

    accountDTO = {
        'id': null,
        'fundraisingPrincipalId': null,
        'email': null,
        'organizationname': null,
        'organizationtype': null,
        'salesRep': null,
        'zip': null,
        'region': null
    };

    campaignDTO = {
        'campaignId': null,
        'campaignname': null,
        'iduser': null,
        'id_fundraising': null,
        'startdate': null,
        'estimatedcompletiondate': null,
        'axxessrepresentative': null
    };

    orderDTO = {
        'campaignId': null,
        'qtyForms': null,
        'qtyMemberships': null,
        'requestBanner': null,
        'specialInstructions': null,
        'shipToContact': null,
        'shipToAddress': null,
        'shipToCity': null,
        'shipToState': null,
        'shipToZipcode': null,
        'orderType': null,
        'billingType': null,
        'totalDueOrder': null
    };


    constructor(private router: Router,
                private accountService: AccountService,
                private campaignService: CampaignService,
                private cdService: CommonDataService,
                private settingsService: SettingsService,
                private userService: UserService,
                private ordersService: FundraiserOrderMaterialsService,
                private scrollTopService: ScrollTopService) {

        this.formGroup = new FormGroup({
            'organizationName': new FormControl('', Validators.required),
            'organizationType': new FormControl('', Validators.required),
            'salesRep': new FormControl('', Validators.required),
            'zip': new FormControl('', Validators.required),
            'startDate': new FormControl('', Validators.required),
            'qtyForms': new FormControl(''),
            'qtyMemberships': new FormControl( ''),
            'requestBanner': new FormControl(''),
            'specialInstructions': new FormControl(''),
            'shipToContact': new FormControl('', Validators.required),
            'shipToAddress': new FormControl('', Validators.required),
            'shipToCity': new FormControl('', Validators.required),
            'shipToState': new FormControl('', Validators.required),
            'shipToZipcode': new FormControl('', Validators.required),
            'checkOrganizationAddress': new FormControl('')
        });

        this.orgTypeList.push({id: 'SCHOOL', value: 'School or school-affiliated'});
        this.orgTypeList.push({id: 'NONPROFIT', value: 'Non-profit (not school-affiliated)'});
    }

    ngOnInit() {
        this.scrollTopService.setScrollTop();

        this.userService.currentUser().subscribe(user => {
            this.currentUser = user;
        }, error => {
            console.log('Error get current user');
        });

        this.getSalesRep();
    }


    validationFields() {

        // if (!this.formGroup.get('campaign').valid) {
        //     this.msg.push({severity: 'error', detail: 'Please enter a value for Select Campaign'});
        // }

        if (!this.formGroup.get('salesRep').valid) {
            this.msg.push({severity: 'error', detail: 'Please select an Axxess sales representative'});
        }

        if (!this.formGroup.get('organizationName').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter an organization name'});
        }

        if (!this.formGroup.get('organizationType').valid) {
            this.msg.push({severity: 'error', detail: 'Please select the organization type'});
        }

        if (!this.formGroup.get('zip').valid) {
            this.msg.push({severity: 'error', detail: 'Select enter the ZIP code of the organization'});
        }

        if (!this.formGroup.get('qtyForms').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter how many packets you require'});
        }

        if (!this.formGroup.get('qtyMemberships').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter how many memberships you require'});
        }

        if (!this.formGroup.get('startDate').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a valid campaign start date'});
        }

        if (!this.formGroup.get('shipToContact').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Contact'});
        }

        if (!this.formGroup.get('shipToAddress').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Address'});
        }

        if (!this.formGroup.get('shipToCity').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for City'});
        }

        if (!this.formGroup.get('shipToState').valid) {
            this.msg.push({severity: 'error', detail: 'Please select a value for State'});
        }

        if (!/^[0-9]{5}$/.test(this.formGroup.value.shipToZipcode)) {
            this.msg.push({severity: 'error', detail: 'Please enter a valid ZIP code'});
        } else {
            if (!this.formGroup.get('shipToZipcode').valid) {
                this.msg.push({severity: 'error', detail: 'Please enter a value for ZIP code'});

                if (this.formGroup.value.shipToZipcode.length < 5) {
                    this.msg.push({severity: 'error', detail: 'ZIP code must be 5 digits'});
                }
            }
        }

    }

    setOrgType() {
        this.nonProfit = this.formGroup.value.organizationType === 'NONPROFIT';
    }

    getSalesRep() {
        const listParams = {
            'filter': {
                'fields': [
                    {
                        'field': 'status',
                        'value': 'ENABLED'
                    },
                ]
            },
            'paging': {
                'page': 1,
                'numRows': 0
            }
        };

        this.settingsService.listSalesRep(listParams)
            .subscribe(
                data => {
                    if (data) {
                        data.salesReps.forEach(function (rep) {
                            rep.marketNames.forEach(function (marketName) {
                                if (marketName === 'FUNDRAISING') {
                                    this.salesRepList.push({
                                        id: rep.id,
                                        value: rep.name,
                                        order: rep.name === 'I\'m Not Sure' ? '_' : rep.name
                                    });
                                }
                            }.bind(this));
                        }.bind(this));

                        this.salesRepList.sort(function (a, b) {
                            if (a.order > b.order) {
                                return 1;
                            }
                            if (a.order < b.order) {
                                return -1;
                            }

                            return 0;
                        });

                        // this.salesRepsMarkets = Object.keys(this.salesRepsList);
                        // this.salesRepsMarkets.sort();
                    }
                }, error => {
                    if (error.message) {
                        this.msg.push({severity: 'error', detail: error.message});
                    } else {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    }
                });
    }

    submit() {
        this.msg = [];
        this.validationFields();
        this.submitAccount();
    }

    submitAccount() {
        if (this.formGroup.valid === false || this.msg.length > 0) {
            return;
        }

        this.accountDTO.id = this.currentUser.id;
        this.accountDTO.email = this.currentUser.email;
        this.accountDTO.organizationname = this.formGroup.value.organizationName;
        this.accountDTO.organizationtype = this.formGroup.value.organizationType;
        this.accountDTO.salesRep = this.formGroup.value.salesRep;
        this.accountDTO.zip = this.formGroup.value.zip;
        this.accountDTO.region = this.campaignService.determineRegionFromZip(this.accountDTO.zip);

        const data = this.cdService.trimObjectData(this.accountDTO);
        this.accountService.save(data)
            .subscribe(
                data => {
                    this.submitCampaign();
                },
                error => {
                    if (error.parameterErrors && error.parameterErrors.length !== 0) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            if (error.parameterErrors[i].message === 'EmptyNotAllowed') {
                                error.parameterErrors[i].message = 'Please fill the required fields';
                            }
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else {
                        this.msg.push({severity: 'error', detail: error.message});
                    }
                }
            );
    }

    submitCampaign() {
        if (this.formGroup.valid === false || this.msg.length > 0) {
            return;
        }

        this.campaignDTO.iduser = this.currentUser.id;
        this.campaignDTO.id_fundraising = this.currentUser.fundraisingPrincipalId;
        this.campaignDTO.startdate = this.formGroup.value.startDate;
        this.campaignDTO.estimatedcompletiondate = new Date(this.formGroup.value.startDate.getTime() + 1209600000);
        this.campaignDTO.campaignname = this.generateCampaignName();
        this.campaignDTO.axxessrepresentative = this.formGroup.value.salesRep;

        this.campaignService.saveCampaigns(this.campaignDTO)
            .subscribe(
                data => {
                    this.orderDTO.campaignId = data;
                    this.submitOrder();
                },
                error => {

                    if (error.parameterErrors && error.parameterErrors.length !== 0) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            if (error.parameterErrors[i].message === 'EmptyNotAllowed') {
                                error.parameterErrors[i].message = 'Please fill the required fields';
                            }
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else {
                        this.msg.push({severity: 'error', detail: error.message});
                    }
                }
            );
    }

    submitOrder() {

        if (this.formGroup.valid === false || this.msg.length > 0) {
            return;
        }

        this.orderDTO.qtyForms = this.formGroup.value.qtyForms;
        this.orderDTO.qtyMemberships = this.formGroup.value.qtyMemberships;
        this.orderDTO.requestBanner = this.formGroup.value.requestBanner;
        this.orderDTO.specialInstructions = this.formGroup.value.specialInstructions;
        this.orderDTO.shipToContact = this.formGroup.value.shipToContact;
        if (this.formGroup.value.checkOrganizationAddress) {
            this.orderDTO.shipToContact += ' / ' + this.formGroup.value.organizationName;
        }
        this.orderDTO.shipToAddress = this.formGroup.value.shipToAddress;
        this.orderDTO.shipToCity = this.formGroup.value.shipToCity;
        this.orderDTO.shipToState = this.formGroup.value.shipToState;
        this.orderDTO.shipToZipcode = this.formGroup.value.shipToZipcode;
        this.orderDTO.orderType = this.nonProfit ? 1 : 0;
        this.orderDTO.totalDueOrder = (this.formGroup.value.qtyMemberships || 0) * 27;
        this.orderDTO.billingType = 0;

        const data = this.cdService.trimObjectData(this.orderDTO);

        this.ordersService.createOrder(data)
            .subscribe(
                data => {
                    this.cdService.setUnsavedChanges(false);
                    this.campaignService.broadcastCampaignId(this.orderDTO.campaignId);
                    this.router.navigate(['campaign', 'manage', this.orderDTO.campaignId]);
                },
                error => {
                    if (error.parameterErrors !== undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else if (error.message.length !== 0) {
                        this.msg.push({severity: 'error', detail: error.message});
                    }
                }
            );
    }

    generateCampaignName() {
        const startDate = new Date(this.campaignDTO.startdate);
        return this.accountDTO.organizationname + ' - ' + this.calculateSeason(startDate) + ' ' + startDate.getFullYear();
    }

    calculateSeason(dateobj) {
        switch (dateobj.getMonth() + 1) {
            case 12:
            case 1:
            case 2:
                return 'Winter';
            case 3:
            case 4:
            case 5:
                return 'Spring';
            case 6:
            case 7:
            case 8:
                return 'Summer';
            case 9:
            case 10:
            case 11:
                return 'Fall';
        }
    }

    formatZip(value) {
        if (value === undefined) {
            return '';
        }
        value = value.toString().replace(/[^0-9]/g, '');
        if (value.length > 9) {
            value = value.slice(0, 9);
        }
        if (value.length > 5) {
            value = value.slice(0, 5) + '-' + value.slice(5);
        }

        return value;
    };

    formatZipCode(event) {
        const keycode = event.keyCode;
        const isTextInputKey =
            (keycode > 47 && keycode < 58) || // number keys
            keycode === 32 || keycode === 8 || // spacebar or backspace
            (keycode > 64 && keycode < 91) || // letter keys
            (keycode > 95 && keycode < 112) || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223);   // [\]' (in order)
        if (isTextInputKey) {
            if (!event.currentTarget.value || event.currentTarget.value == 0) {
                return;
            }
            event.currentTarget.value = this.formatZip(event.currentTarget.value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign-create/campaign-create.component.ts